import React from 'react';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50" data-testid="privacy-policy-page">
      <SEO 
        title="Privatumo politika | WSK Logistikos paslaugos"
        description="Sužinokite, kaip MB „WSK Logistikos paslaugos“ tvarko ir saugo Jūsų asmens duomenis, laikydamasi galiojančių teisės aktų."
        keywords="privatumo politika, asmens duomenų apsauga, BDAR, duomenų tvarkymas"
      />
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Privatumo politika</h1>
          <p className="text-xl text-blue-100">
            Atnaujinta: {new Date().toLocaleDateString('lt-LT')}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Bendrosios nuostatos</h2>
              <p className="text-gray-600 leading-relaxed">
                MB „WSK Logistikos paslaugos" (toliau – WSK Logistika arba Bendrovė) gerbia jūsų privatumą
                ir įsipareigoja saugoti jūsų asmens duomenis. Ši privatumo politika aprašo, kaip renkame,
                naudojame, saugome ir apsaugome jūsų asmens duomenis.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Duomenų valdytojas</h2>
              <p className="text-gray-600 leading-relaxed mb-2">
                Jūsų asmens duomenų valdytojas yra:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700">MB „WSK Logistikos paslaugos"</p>
                <p className="text-gray-700">Adresas: Ateities pl. 28 c, LT-52181 Kaunas</p>
                <p className="text-gray-700">El. paštas: info@wsklogistika.lt</p>
                <p className="text-gray-700">Telefonas: +370 650 17855</p>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Kokius duomenis renkame</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Teikdami užklausą ar naudodamiesi mūsų paslaugomis, galite pateikti šiuos duomenis:
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Įmonės pavadinimas
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Kontaktinio asmens vardas ir pavardė
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  El. pašto adresas
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Telefono numeris
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Informacija apie domėjimąsi paslaugomis
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Duomenų naudojimo tikslai</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Jūsų asmens duomenis naudojame šiais tikslais:
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Atsakyti į jūsų užklausas ir pateikti pasiūlymus
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Teikti logistikos paslaugas
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Palaikyti komunikaciją su klientais
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Vykdyti sutartinius įsipareigojimus
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Gerinti mūsų paslaugų kokybę
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Duomenų saugojimas</h2>
              <p className="text-gray-600 leading-relaxed">
                Jūsų asmens duomenis saugome tik tiek laiko, kiek būtina nurodytais tikslais arba kiek
                reikalauja teisės aktai. Užklausų duomenis saugome ne ilgiau kaip 3 metus po paskutinio
                kontakto, nebent teisės aktai reikalauja ilgesnio saugojimo termino.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Jūsų teisės</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Pagal BDAR turite šias teises:
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Teisę gauti informaciją apie savo duomenų tvarkymą
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Teisę susipažinti su savo duomenimis
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Teisę ištaisyti netikslius duomenis
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Teisę ištrinti savo duomenis
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Teisę apriboti duomenų tvarkymą
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Teisę į duomenų perkeliamumą
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Duomenų apsauga</h2>
              <p className="text-gray-600 leading-relaxed">
                Taikome atitinkamas technines ir organizacines priemones, kad apsaugotume jūsų asmens duomenis
                nuo atsitiktinio ar neteisėto sunaikinimo, pakeitimo, atskleidimo ar bet kokio kito neteisėto
                tvarkymo.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Kontaktai</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Jei turite klausimų apie šią privatumo politiką ar savo asmens duomenų tvarkymą,
                susisiekite su mumis:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700">El. paštas: info@wsklogistika.lt</p>
                <p className="text-gray-700">Telefonas: +370 650 17855</p>
                <p className="text-gray-700">Adresas: Ateities pl. 28 c, LT-52181 Kaunas</p>
              </div>
            </div>

            <div className="pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500 italic">
                Šią privatumo politiką galime atnaujinti. Apie esminius pakeitimus informuosime svetainėje.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
